import React from 'react';
import PropTypes from 'prop-types';
import { BasicForm } from './BasicForm.jsx';
import { FormLabel } from '../FormLabel.jsx';
import { FormErrorMessage } from '../FormErrorMessage.jsx';
import Icon from '@mdi/react';
import { mdiEye, mdiEyeOff } from '../../../../../../images/svg';
import * as textUtil from '../../../../../../utils/textUtil';
import { EmailSuggestion } from './EmailSuggestion.jsx';

export class TextInputForm extends BasicForm {
  state = {
    showPassword: false,
    showEmailSuggestion: false
  };

  getLabelUtilText(object, input) {
    const { systemMessages } = this.props;
    const { validations: { min_words, max_words } } = object;

    if (min_words && min_words > input.value.length) {
      return `${systemMessages.minimumCharacterCount}: ${textUtil.replaceNumber(systemMessages.characters, min_words)}`;
    }
    else if (max_words) {
      return textUtil.replaceNumber(systemMessages.characters, `${input.value.length}/${max_words}`);
    }
    else {
      return ''
    }
  }

  componentDidUpdate() {
    if (this.props.inputType === 'email' && textUtil.emailDomainOptions(this.props.input.value).length > 0) {
      if (!this.state.showEmailSuggestion) {
        this.setState({ showEmailSuggestion: true });
      }
    } else {
      if (this.state.showEmailSuggestion) {
        this.setState({ showEmailSuggestion: false });
      }
    }
  }

  onChange(value) {
    const inputValue = this.props.isHalfWidth ? this.toHalfWidth(value) : value;
    this.props.input.onChange(inputValue);
  }

  handleChange(event) {
    this.onChange(event.target.value)
  }

  toHalfWidth(text) {
    return text.replace(/[！-～]/g, (r) => {
      return String.fromCharCode(r.charCodeAt(0) - 0xFEE0);
    });
  }

  render() {
    const { object, input, meta, disabled, inputType, inputMode } = this.props;
    const { validations: { max_words } } = object;
    const _inputType = inputType
      ? inputType === 'password'
        ? this.state.showPassword
          ? 'text' : 'password'
        : inputType
      : 'text';
    const _inputMode = inputMode
      ? inputType === 'password'
        ? this.state.showPassword
          // Use url inputmode in order to show english keyboard, otherwise use default
          ? 'url' : undefined
        : inputMode
      : 'text';

    return (
      <div className="cu-ui-form-group">
        <FormLabel
          valid={meta.valid}
          label={object.label}
          required={max_words && max_words < input.value.length ? false : object.validations.required}
          utilText={this.getLabelUtilText(object, input)}
        />
        <div className="cu-ui-input-container">
          {object.data.enableEmailSuggestion && this.state.showEmailSuggestion &&
            <EmailSuggestion
              suggestions={textUtil.emailDomainOptions(input.value)}
              onClick={(value) => this.onChange(input.value.substring(0, input.value.lastIndexOf('@') + 1) + value)}
              callback={(value) => this.setState({ showEmailSuggestion: value })}
            />
          }
          <input
            {...input}
            type={_inputType}
            inputMode={_inputMode}
            className="cu-ui-input"
            placeholder={object.data.placeholder}
            disabled={disabled}
            onChange={this.handleChange.bind(this)}
            onFocus={this.handleFocusInput(input.onFocus)}
            onBlur={this.handleBlurInput(input.onBlur)}
          />
          {
            inputType === 'password' &&
            <Icon
              className="cu-ui-show-password"
              path={this.state.showPassword ? mdiEye : mdiEyeOff}
              onClick={() => this.setState({ showPassword: !this.state.showPassword })}
            />
          }
        </div>
        <FormErrorMessage
          error={meta.error}
          touched={meta.touched}
        />
      </div>
    );
  }
}
